import {ERROR, LOADING, LOGGED_OUT, SIGN_IN, SIGN_IN_TOKEN_REQUIRED, SIGNED_IN} from "module/constants";
import common from "module/common";
import socket from 'module/socket';
import {fetchAuthenticatedUser} from "./authPayload";

const LOGGED_IN_USER = 'loggedInUser';

const SET_STATE = 'loggedInState';
const SET_STATE_REASON = 'loggedInStateReason';

const SET_LOGGED_IN_USER = 'loggedInUser';
const SET_ALL_USERS = 'allUsers';

const RESET_LOGGED_IN_USER = 'resetLoggedInUser';

export const actions = {
  initEmailToken({commit, dispatch, state}) {
    const loggedInState = _.get(state, `${LOGGED_IN_USER}.state.state`, null);

    if (loggedInState === SIGN_IN || loggedInState === SIGN_IN_TOKEN_REQUIRED) {
      return;
    }

    if (loggedInState !== SIGNED_IN) {
      commit(SET_STATE, SIGN_IN);
    }
  },
  sendConfirmation({state, commit, dispatch}, email) {
    commit(SET_STATE, LOADING);

    common
      .httpPost('user')
      .recaptchaAction('sendConfirmation')
      .data({login: 'sendConfirmation', email})
      .then((res) => {
        commit(SET_STATE, SIGN_IN_TOKEN_REQUIRED);
      }, (error) => {
        dispatch('error/error', error, {root: true});
        commit(SET_STATE, ERROR);
        commit(SET_STATE_REASON, _.get(error, 'data.message', null));
      });
  },
  sendResetPasswordEmail({state, commit, dispatch}, email) {
    commit(SET_STATE, LOADING);

    common
      .httpPost('user')
      .recaptchaAction('sendResetPasswordEmail')
      .data({login: 'sendResetPasswordEmail', email})
      .then((res) => {
        commit(SET_STATE, SIGN_IN_TOKEN_REQUIRED);
      }, (error) => {
        dispatch('error/error', error, {root: true});
        commit(SET_STATE, ERROR);
        commit(SET_STATE_REASON, _.get(error, 'data.message', null));
      });
  },
  confirmLogin({state, commit, dispatch}, {email, token}) {
    common
      .httpPost('user')
      .recaptchaAction('confirmLogin')
      .data({login: 'confirmLogin', email, token})
      .then(() => {
        fetchAuthenticatedUser().then((loggedInUser) => {
          if (!loggedInUser) {
            commit(SET_STATE, SIGN_IN_TOKEN_REQUIRED);
            commit(SET_STATE_REASON, 'Login completed, but we could not load your user details. Please try again.');
            return;
          }

          commit(SET_LOGGED_IN_USER, loggedInUser);
          commit(SET_STATE, SIGNED_IN);
          dispatch('brand/load', null, {root: true});
          dispatch('externalProvider/load', null, {root: true});
          dispatch('reportPack/load', null, {root: true});
          socket.validate();
        }, ({response}) => {
          commit(SET_STATE, ERROR);
          if (response && response.body && response.body.message) {
            commit(SET_STATE_REASON, response.body.message);
          }
        });
      }, ({response}) => {
        commit(SET_STATE, SIGN_IN_TOKEN_REQUIRED);
        if (response && response.body && response.body.message) {
          commit(SET_STATE_REASON, response.body.message);
        }
      });
  },
  passwordLogin({state, commit, dispatch}, {email, password}) {
    if (!email || !password) {
      return;
    }

    common
      .httpPost('user')
      .recaptchaAction('passwordLogin')
      .data({login: 'password', email, password})
      .then(() => {
        fetchAuthenticatedUser().then((loggedInUser) => {
          commit(SET_LOGGED_IN_USER, loggedInUser);
          commit(SET_STATE, SIGNED_IN);
          dispatch('brand/load', null, {root: true});
          dispatch('externalProvider/load', null, {root: true});
          dispatch('reportPack/load', null, {root: true});
          socket.validate();
        }, ({response}) => {
          commit(SET_STATE, ERROR);
          if (response && response.body && response.body.message) {
            commit(SET_STATE_REASON, response.body.message);
          }
        });
      }, ({response}) => {
        commit(SET_STATE, ERROR);
        if (response && response.body && response.body.message) {
          commit(SET_STATE_REASON, response.body.message);
        }
      });
  },
  legacyUserManageSave({commit,dispatch}, user){
    common
      .httpPost('externalUser')
      .data({
        manage: user.isNew === true ? 'addUser' : 'updateUser',
        existingEmail: user.existingEmail,
        name: user.name,
        email: user.email,
        groups: user.groups,
        limitations: user.limitations
      })
      .then((res) => {
        commit(SET_ALL_USERS, res.data.all);
      }, ({response}) => {
        dispatch('error/error', error, {root: true});
      });
  }
};

export const getters = {
  canManageUsers(state) {
    return state.loggedInUser.user.limitations.filter(({limit}) => limit === 'MANAGE_USERS').length >= 1
  }
};
